export function translate(key) {
    return window.translations?.[key] ?? key
}
